const formatLocation = (country: string, city?: string, location?: string) => {
	return `${country}${(city && `, ${city}`) || ''}${(location && `, ${location}`) || ''}`
}
export default formatLocation
